// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__aX3Yh","subheader":"ReorderModal_subheader__3oVft","listWrap":"ReorderModal_listWrap__ekN5X"};